<style>
  #globalSearchContainer {
    display: table;
    width: 100%;
    height: 60px;
    z-index: 100000;
  }

  #searchBoxContainer {
    background-color: #ffffff;
    display: flex;
    align-items: center;

    > mat-icon {
      color: #22cccc;
      font-size: 25px;
    }

    input[type='text'] {
      width: 100%;
      height: 40px;
      border: none;
      padding: 0px 0px 0px 10px;
      margin: 0px;
      font-size: 1.2em;
    }

    input:focus {
      outline: none;
    }
  }

  #searchResultsContainer {
    position: fixed;
    width: 100%;
    max-height: 300px;
    margin-top: 0px;
    margin: 0px;
    padding: 0px 0px 0px 0px;
    overflow-y: scroll;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 0px 0px 5px 5px;
  }

  .scrollableContent {
    overflow-y: scroll;
    max-height: 100%;
    padding: 0px;
  }

  .record {
    width: 98%;
    border-bottom: 1px solid #dddddd;
    padding: 5px;
  }

  .record.highlightable:hover {
    background-color: #eeeeee;
    cursor: pointer;
  }
</style>

<div id="globalSearchContainer">
  <div style="display: table-row">
    <div style="display: table-cell; vertical-align: middle">
      <div
        style="
          background-color: #ffffff;
          white-space: nowrap;
          height: 40px;
          margin-right: 5px;
        "
      >
        <div
          style="
            padding: 5px 10px;
            width: 120px;
            height: 30px;
            background-color: inherit;
            cursor: pointer;
          "
        >
          <div
            style="display: table; width: 100%; height: 100%"
            (click)="ddlFilters_click()"
          >
            <div
              style="
                display: table-cell;
                vertical-align: middle;
                text-align: center;
              "
            >
              Filters
            </div>
          </div>
        </div>
        <div
          [hidden]="!displayFilterOptions"
          style="
            background-color: #ffffff;
            border: 1px solid #aaaaaa;
            border-top: 1px solid #dddddd;
            border-radius: 0px 0px 5px 5px;
          "
        >
          <div style="padding: 5px">
            <div>
              <input
                type="checkbox"
                [(ngModel)]="filterMerchants"
                (ngModelChange)="handleFiltersChanged()"
              />
              Merchants
            </div>
            <div>
              <input
                type="checkbox"
                [(ngModel)]="filterCustomers"
                (ngModelChange)="handleFiltersChanged()"
              />
              Customers
            </div>
            <div>
              <input
                type="checkbox"
                [(ngModel)]="filterTransactions"
                (ngModelChange)="handleFiltersChanged()"
              />
              Transactions
            </div>
            <div>
              <input
                type="checkbox"
                [(ngModel)]="filterUsers"
                (ngModelChange)="handleFiltersChanged()"
              />
              Users
            </div>
            <div>
              <input
                type="checkbox"
                [(ngModel)]="filterBusinesses"
                (ngModelChange)="handleFiltersChanged()"
              />
              Businesses
            </div>
            <div>
              <input
                type="button"
                class="button_secondary button_var_2"
                style="width: 100%"
                value="select"
                (click)="btnRefineFilters_click()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: table-cell; vertical-align: middle; width: 100%">
      <div id="searchBoxContainer">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (focus)="txtSearch_focus()"
          (blur)="txtSearch_blur()"
          (keyup)="txtSearch_keyup()"
        />
      </div>
    </div>
  </div>
</div>

<div
  [hidden]="!displayResults"
  id="searchResultsContainer"
  style="z-index: 9999"
>
  <div style="padding: 8px">
    @for (
      item of this.dataSource;
      track item;
      let even = $even;
      let odd = $odd
    ) {
      @if (item.id != undefined) {
        <div
          id="trsummary_{{ item.id }}"
          [ngClass]="{ even: even, odd: odd }"
          class="record highlightable"
          (click)="selectRow_click(item)"
        >
          <div style="display: table-row">
            <div style="display: table-cell; padding-right: 10px">
              <mat-icon title="{{ getTypeTitle(item.type) }}">{{
                getTypeIcon(item.type)
              }}</mat-icon>
            </div>
            <div style="display: table-cell; width: 100%">{{ item.name }}</div>
          </div>
          <div
            [innerHTML]="
              formatDetails(item.type, item.details) | safeHtml: 'html'
            "
          ></div>
        </div>
      }
    }
  </div>
</div>
